import { render, staticRenderFns } from "./ThemeConfig.vue?vue&type=template&id=0aeb42c1"
import script from "./ThemeConfig.vue?vue&type=script&lang=js"
export * from "./ThemeConfig.vue?vue&type=script&lang=js"
import style0 from "./ThemeConfig.vue?vue&type=style&index=0&id=0aeb42c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports